var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"chart"}},[(_vm.products.length > 0)?_c('div',[_c('apexchart',{attrs:{"type":"bar","height":"220","options":_vm.chartOptions,"series":_vm.series}})],1):_c('div',{staticClass:"error mt-5"},[_c('h2',{staticClass:"mt-5"},[_vm._v(" "+_vm._s(_vm.$t("message.no_data_yet"))+" ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }